import { IdFilter, StringFilter } from 'core/filters';
import { ModelFilter } from 'core/models';



export class LoginConfigurationContentFilter extends ModelFilter {
  public id?: IdFilter = new IdFilter();
  public code?: StringFilter = new StringFilter();
  public name?: StringFilter = new StringFilter();
  public value?: StringFilter = new StringFilter();
  public loginConfigurationId?: IdFilter = new IdFilter();
}
